module.exports = __webpack_public_path__ + "assets/chat_outline-95c020.svg";